import { Content } from 'shared/components/Content';
import { EOfferType, EDealType } from 'shared/types/wantType';
import { useCallback, useState } from 'react';
import { TGuideList } from 'shared/types/guide';
import { SALE_GUIDE_LIST } from 'shared/constants/sell';
import { RENT_GUIDE_LIST } from 'shared/constants/rent';
import { filterByType } from 'shared/utils/filterByType';
import { useSelector } from 'react-redux';
import { selectDealType } from 'shared/selectors/dealType';
import { selectOfferType } from 'shared/selectors/offerType';
import { CatContainer } from '../CatContainer';
import { useAppDispatch } from 'shared/hooks';
import { setDealType, setOfferType } from 'shared/slices';
import { prepareCategoryCa } from 'shared/utils/prepareCategoryCa';
import { caPageCategory } from 'shared/components/tracking';
import { Switcher } from 'shared/components/Switcher';
import { HOSTS_GUIDE_LIST } from 'shared/constants/hosts';
import { EffectPlaceCianContainer } from '../EffectPlaceCian';
import { SocialsBlock } from 'shared/components/SocialsBlock';
import { ListContainer } from '../List';
import { QuestionsContainer } from '../Questions';

export const ContentContainer: React.FC = () => {
  const dealType = useSelector(selectDealType);

  const offerType = useSelector(selectOfferType);

  const caCategory = prepareCategoryCa(dealType, offerType);

  const dispatch = useAppDispatch();

  const switchList = useCallback((value: EDealType) => {
    switch (value) {
      case EDealType.Rent:
        return RENT_GUIDE_LIST;
      case EDealType.Host:
        return HOSTS_GUIDE_LIST;
      default:
        return SALE_GUIDE_LIST;
    }
  }, []);

  const list = switchList(dealType);

  const [activeList, setActiveList] = useState<TGuideList[]>(filterByType(list, offerType));

  const handleActiveDeal = useCallback(
    (newItem: EDealType) => {
      const newList = switchList(newItem);

      caPageCategory(prepareCategoryCa(newItem, offerType));

      dispatch(setDealType(newItem));

      setActiveList(filterByType(newList, offerType));
    },
    [dispatch, offerType, switchList],
  );

  const handleActiveOffer = useCallback(
    (newType: EOfferType) => {
      dispatch(setOfferType(newType));

      caPageCategory(prepareCategoryCa(dealType, newType));

      setActiveList(filterByType(list, newType));
    },
    [dealType, dispatch, list],
  );

  return (
    <Content>
      <EffectPlaceCianContainer />
      <Switcher
        dealType={dealType}
        offerType={offerType}
        onActiveOfferType={handleActiveOffer}
        onActiveDealType={handleActiveDeal}
      />
      <ListContainer list={activeList} caCategory={caCategory} />
      <QuestionsContainer />
      <SocialsBlock />
      <CatContainer />
    </Content>
  );
};
